(function () {
  const overlay = document.getElementById('upsell-popup-overlay');
  if (!overlay) return;

  let activeForm = null;
  let skipUpsell = false;

  // ── Session-Flag: Popup nur 1x pro Browser-Session ──────────────────
  const STORAGE_KEY = 'aromes_upsell_shown';

  function isPopupUsed() {
    try { return sessionStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { return false; }
  }

  function markPopupUsed() {
    try { sessionStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
  }

  function isMainProductForm(form) {
    const excluded = form.closest(
      '[data-gift-products],' +
      '.gift-with-purchase,' +
      '.gifts-on-quantity,' +
      '.gift-products,' +
      '.upsell-popup,' +
      '.upsell-modal,' +
      '#upsell-popup-overlay,' +
      '.quick-add,' +
      '.quick-shop,' +
      '[data-quick-add],' +
      '.cart-drawer,' +
      '.cart__drawer,' +
      '[data-cart-drawer]'
    );
    if (excluded) return false;

    const productSection = form.closest(
      '.product,' +
      '.product__info-wrapper,' +
      '[data-product],' +
      '[data-section-type="product"],' +
      '.product-form,' +
      'section[id*="product"],' +
      '.shopify-section-template--product,' +
      'main'
    );
    return !!productSection;
  }

  // ── 1. Haupt-Add-to-Cart Formulare abfangen ────────────────────────
  function interceptForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      if (form.dataset.upsellBound) return;
      form.dataset.upsellBound = 'true';

      if (!isMainProductForm(form)) return;

      form.addEventListener('submit', function (e) {
        if (skipUpsell || isPopupUsed()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        activeForm = form;
        openPopup();
      }, true);
    });
  }

  // ── 2. Sticky ATC Button abfangen ───────────────────────────────────
  function interceptStickyBtn() {
    document.querySelectorAll('.sticky-atc__add_button').forEach(btn => {
      if (btn.dataset.upsellBound) return;
      btn.dataset.upsellBound = 'true';

      btn.addEventListener('click', function (e) {
        if (skipUpsell || isPopupUsed()) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        const formId = btn.getAttribute('form');
        const form = formId
          ? document.getElementById(formId)
          : btn.closest('form');

        if (form) {
          activeForm = form;
          openPopup();
        }
      }, true);
    });
  }

  interceptForms();
  interceptStickyBtn();

  const observer = new MutationObserver(() => {
    interceptForms();
    interceptStickyBtn();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ── 3. Popup öffnen / schließen ─────────────────────────────────────
  function openPopup() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── 4. Upsell per Ajax hinzufügen ──────────────────────────────────
  //    Einzigartige _upsell_id Property verhindert, dass Shopify
  //    identische Upsells zu einem Line-Item zusammenführt.
  async function addUpsellToCart(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: {
          '_upsell': 'true',
          '_upsell_id': Date.now().toString(36)
        }
      })
    });
  }

  // ── 5. Originales Formular nativ re-submitten ───────────────────────
  function submitOriginalForm() {
    if (!activeForm) return;
    skipUpsell = true;

    if (typeof activeForm.requestSubmit === 'function') {
      activeForm.requestSubmit();
    } else {
      activeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    setTimeout(() => {
      skipUpsell = false;
      activeForm = null;
    }, 3000);
  }

  // ── 6. Popup schließen + Aktion ausführen ───────────────────────────
  async function handleClose(upsellVariantId = null) {
    closePopup();
    markPopupUsed();

    if (upsellVariantId) {
      await addUpsellToCart(upsellVariantId);
    }

    submitOriginalForm();

    setTimeout(markUpsellItems, 800);
    setTimeout(markUpsellItems, 2000);
  }

  // ── 7. Upsell-Items im Cart-Drawer markieren ───────────────────────
  async function markUpsellItems() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const upsellVariantIds = new Set();
      cart.items.forEach(item => {
        if (item.properties && item.properties._upsell === 'true') {
          upsellVariantIds.add(String(item.variant_id));
        }
      });

      if (upsellVariantIds.size === 0) return;

      document.querySelectorAll('.cart-item, .cart-drawer-item').forEach(li => {
        const qtyInput = li.querySelector('input[data-quantity-variant-id]');
        if (qtyInput && upsellVariantIds.has(qtyInput.dataset.quantityVariantId)) {
          li.setAttribute('data-upsell', 'true');
        }
      });
    } catch (e) {}
  }

  markUpsellItems();

  const cartObserver = new MutationObserver(() => markUpsellItems());
  const cartDrawer = document.querySelector('.cart-drawer, [data-cart-drawer], #CartDrawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  // ── 8. Upsell-Karten (Button + Karten-Klick) ────────────────────────
  overlay.querySelectorAll('.upsell-add-btn').forEach(btn => {
    btn.addEventListener('click', async function () {
      if (btn.disabled) return;
      const variantId = this.dataset.variant;
      this.textContent = '✓ Hinzugefügt';
      this.classList.add('is-added');
      this.disabled = true;
      setTimeout(() => handleClose(variantId), 500);
    });
  });

  overlay.querySelectorAll('.upsell-card').forEach(card => {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.upsell-add-btn')) return;
      const btn = card.querySelector('.upsell-add-btn');
      if (btn && !btn.disabled) btn.click();
    });
  });

  // ── 9. Skip / Close ─────────────────────────────────────────────────
  document.getElementById('upsell-skip-btn').addEventListener('click', () => handleClose());
  document.getElementById('upsell-close-btn').addEventListener('click', () => handleClose());
  overlay.addEventListener('click', e => { if (e.target === overlay) handleClose(); });

})();